import React from 'react';
import $ from "jquery";

function req(endpoint) {
  if (endpoint[0] === '/') {
    endpoint = endpoint.substr(1);
  }

  endpoint += endpoint.indexOf('/?') === -1 ? '?' : '&';

  return $.get(`/api/v2/${endpoint}limit=24`);
}

export default function dataFetch(WrappedComponent) {
  return function(endpoint) {
    return class extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          completed: false,
          failed: false,
          items: []
        };
      }

      shouldComponentUpdate(nextProps, nextState) {
        return this.state.completed !== nextState.completed;
      }

      componentDidMount() {
        req(endpoint)
          .then(resp => {
            if (typeof resp.map !== 'function') {
              throw "Invalid server response";
            }

            this.setState(() => {
              return {
                items: resp.map(w => {
                  w.id = w.full_length && (w.full_length.id || w.full_length.mm_id) || (w.post && w.post.ID);
                  return w;
                }),
                completed: true
              };
            });
          })
          .catch((err) => {
            console.error(`Failed to load ${endpoint}`, err);

            this.setState(() => {
              return { completed: true, failed: true };
            });
          });
      }

      render() {
        return <WrappedComponent
          items={this.state.items}
          failedToLoad={this.state.completed && this.state.failed}
          {...this.props} />;
      }
    }
  };
}